import { useMemo } from 'react';
import { ClientAccountListHostProps } from 'shared/clientAccountList';
import { useClientData } from '@/providers/ClientData.provider';

// The one place client-dashboard maps its own account model + routes onto what the shared Client Account
// List feature takes as props (ID-13350). Used where the feature is mounted (the /client-accounts route);
// partner-dashboard writes its own equivalent from its own providers when it embeds the list.
export default function useClientAccountListHostProps(): ClientAccountListHostProps {
  const {
    response: { Country },
  } = useClientData();

  return useMemo(
    () => ({
      account: { country: Country },
      hostPaths: {
        accountDetail: (clientAccountID: string) => `/client-accounts/${clientAccountID}`,
      },
    }),
    [Country],
  );
}
